window.addEventListener("DOMContentLoaded", () => {

    const input = document.getElementById("share_cartLink");
    const button = document.getElementById("share_invite");

    let debounceTimer;

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    input.addEventListener(
      "change",
      function (e) {
        // Stop Shopify listener (/cart/change)
        e.stopImmediatePropagation();

        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
          const value = input.value.trim();
          button.disabled = !isValidEmail(value);
          button.style.backgroundColor = button.disabled ? "#cecece" : "#3db174";
        }, 300);
      },
      true
    );
});